module.exports = __webpack_public_path__ + "odstraneni-tetovaze_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_3_after.jpg
// module id = 957
// module chunks = 0